import React from "react";
import {
  Tag,
  Divider,
  TimePicker,
  Row,
  Col,
  Button,
  Icon,
  Form,
  Input
} from "antd";
import moment from "moment";
import DayTag from "./DayTag";
import { strings } from "../../../helpers";

const { CheckableTag } = Tag;
const FormItem = Form.Item;
export default class AddEditScheduleView extends React.Component {
  state = { openStartTimePicker: false, openClosingTimePicker: false };

  /**
   * @function toggleStartTimePicker
   * @desc This function toggles start time timepicker field
   */
  toggleStartTimePicker = () => {
    this.setState(prevState => ({
      openStartTimePicker: !prevState.openStartTimePicker
    }));
  };

  /**
   * @function toggleClosingTimePicker
   * @desc This function toggles closing time timepicker field
   */
  toggleClosingTimePicker = () => {
    this.setState(prevState => ({
      openClosingTimePicker: !prevState.openClosingTimePicker
    }));
  };

  render() {
    const {
      handleDailyChange,
      handleStartTimeSelect,
      handleEndTimeSelect,
      schedule,
      dailyChecked,
      saveSchedule,
      cancelSave,
      scheduleId,
      scheduleType,
      handleChangeFees,
      addUpdateCompRef,
      editingStarted
    } = this.props;

    return (
      <div className="" ref={addUpdateCompRef}>
        <div
          className={`detail-panel backgroundWhite ${
            editingStarted ? "animate-border" : ""
          }`}
        >
          <div
            className="light-bg round-5x p-15 eq-column"
            id={`addScheduleForm_${scheduleType}`}
          >
            <h4 className="sch-head">
              {scheduleId ? "Update schedule" : "Select Days"}
            </h4>
            <Row className="schdule-wrap">
              <Col span={24}>
                <div className="schedule_on_fullpage">
                  <div className="compact-schedule-wrapper">
                    <CheckableTag
                      children={"Daily"}
                      checked={dailyChecked}
                      onChange={handleDailyChange}
                      selectValue="Daily"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    />

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Mon"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Mon"}
                    </DayTag>

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Tue"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Tue"}
                    </DayTag>

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Wed"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Wed"}
                    </DayTag>

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Thu"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Thu"}
                    </DayTag>

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Fri"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Fri"}
                    </DayTag>

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Sat"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Sat"}
                    </DayTag>

                    <DayTag
                      dailychecked={dailyChecked.toString()}
                      handleDailyChange={handleDailyChange}
                      selectValue="Sun"
                      // className="schedule-day-box"
                      className="compact-schedule-day-box"
                    >
                      {"Sun"}
                    </DayTag>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <h4 className="sch-head mt-10">Select times</h4>
                <div className="timepickers-wrap mt-10 mb-10">
                  <Row type="flex" align="middle">
                    <Col>
                      <TimePicker
                        use12Hours
                        format="hh:mm a"
                        suffixIcon={<Icon type="down" />}
                        minuteStep={30}
                        placeholder={"Start Time"}
                        onChange={handleStartTimeSelect}
                        value={
                          schedule.start_time
                            ? moment(schedule.start_time)
                            : null
                        }
                        defaultOpenValue={moment("09:00", "hh:mm")}
                        allowClear
                        addon={() => (
                          <Button
                            size="small"
                            type="primary"
                            onClick={this.toggleStartTimePicker}
                          >
                            {"Apply"}
                          </Button>
                        )}
                        open={this.state.openStartTimePicker}
                        onOpenChange={this.toggleStartTimePicker}
                      />
                    </Col>
                    <Col>
                      <div className="mlr-5">-</div>
                    </Col>
                    <Col>
                      <TimePicker
                        use12Hours
                        suffixIcon={<Icon type="down" />}
                        format="hh:mm a"
                        minuteStep={30}
                        placeholder={"Close Time"}
                        onChange={handleEndTimeSelect}
                        value={
                          schedule.end_time ? moment(schedule.end_time) : null
                        }
                        defaultOpenValue={moment("19:00", "hh:mm")}
                        addon={() => (
                          <Button
                            size="small"
                            type="primary"
                            onClick={this.toggleClosingTimePicker}
                          >
                            {"Apply"}
                          </Button>
                        )}
                        open={this.state.openClosingTimePicker}
                        onOpenChange={this.toggleClosingTimePicker}
                      />
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            {scheduleType && scheduleType === "discounted" && (
              <Row className="fees-row">
                <Col span={24}>
                  <FormItem label={`${"Fees"} (₹)*`}>
                    <Input
                      placeholder={"Fees"}
                      type="number"
                      className="fees-input"
                      value={schedule.discounted_fees}
                      onChange={handleChangeFees}
                    />
                  </FormItem>
                </Col>
              </Row>
            )}

            <Row type="flex" className="mt-10" align="start" gutter={10}>
              <Col>
                <Button type="primary" onClick={saveSchedule}>
                  {scheduleId ? "Save" : "Add"}
                </Button>
              </Col>
              <Col>
                <Button type="link" onClick={cancelSave}>
                  {"Cancel"}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
